import { useEffect, useState } from 'react'
import { Mark } from 'wvrio-styleguide';
import styled, { keyframes } from 'styled-components';
import './WeaverLoading.scss'

export default WeaverLoading = ({ style }) ->

  [loading, setLoading] = useState(true)

  useEffect( ->
    setLoading(false)
    undefined
  , [])

  unless loading
    <div style={{ textAlign: 'center', style... }}>
      <StyledMark />
    </div>
  else
    <div />

loadingAnimation = keyframes"""
  10% { opacity: 1 }
  25% { opacity: 0.5 }
  50% { opacity: 0 }
  67% { opacity: 0.5 }
  90% { opacity: 1 }
""";

StyledMark = styled(Mark)"""
  width: 120px;
  height: 85px;
  animation: #{loadingAnimation} linear 1s infinite;
""";